import React from "react";
import { useNavigate } from 'react-router-dom'; 
import inst from "../../assets/Ins.png";
import face from "../../assets/Face.png";
import you from "../../assets/You.png";
import lin from "../../assets/Lin.png";
import twi from "../../assets/Twi.png";
import news from "../../assets/News.png";
import phone from "../../assets/phone.png";
import mail from "../../assets/Mail.png";
import loc from "../../assets/Loc.png";
import nlen from "../../assets/Nlen.svg";
import user from "../../assets/user.png";  

import { toast, ToastContainer } from "react-toastify";

import { useEffect, useState ,useRef} from 'react';


import locationIcon from "../../assets/locationn.png";
import fulltimeIcon from "../../assets/fulltime-icon.png";
import experienceIcon from "../../assets/experience-icon.png";





import gmailIcon from "../../assets/emaill.png";
import xIcon from "../../assets/x.png";
import facebookIcon from "../../assets/facebook.png";
import instagramIcon from "../../assets/instagram.png";
import linkedinIcon from "../../assets/linkedin.png";


const HireUsForm = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
            // const [isServicesOpen, setIsServicesOpen] = useState(false);
            // const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
            // const [isCompanyOpen, setIsCompanyOpen] = useState(false);
          
            const toggleMobileMenu = () => {
              setIsMobileMenuOpen(!isMobileMenuOpen);
            };
          
            // const toggleServicesDropdown = () => {
            //   setIsServicesOpen(!isServicesOpen);
            // };
          
            // const toggleIndustriesDropdown = () => {
            //   setIsIndustriesOpen(!isIndustriesOpen);
            // };
          
            // const toggleCompanyDropdown = () => {
            //   setIsCompanyOpen(!isCompanyOpen);
            // };
      const [data, setData] = useState("");
        const [sessionid, setSessionid] = useState("");
        const [email, setEmail] = useState("");
        const [token, setToken] = useState("");
        useEffect(() => {
          fetch("https://api-uat.mawalog.com/admin/v2/api/website")
            .then((response) => response.json())
            .then((json) => {
              setData(json.data.captcha_code);
              setSessionid(json.data.session_id);
              setToken(json.data.token);
            })
            .catch((error) => console.error("Error fetching data:", error));
        }, []);
        useEffect(() => {
          const canvas = document.getElementById("captchaCanvas");
          if (canvas) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.font = "bold 18px Arial";
            ctx.fillStyle = "#00377B";
            ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
          }
        }, [data]);
        const handleChange = (e) => {
          setEmail(e.target.value);
        };
       
         const canvasRef = useRef(null);
        const [captchaValue, setCaptchaValue] = useState(""); // text from API
        const [userCaptcha, setUserCaptcha] = useState("");
       
        /* ------------------------------------------------------------------- API fetch */
        const fetchCaptcha = async () => {
          try {
            const res = await fetch(
              "https://api-uat.mawalog.com/admin/v2/api/website"
            );
            const json = await res.json();
            setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
          } catch (err) {
            console.error("Error fetching captcha:", err);
          }
        };
       
        /* -- fetch once on mount ------------------------------------------------------- */
        useEffect(() => {
          fetchCaptcha();
        }, []);
       
        /* -- redraw every time captchaValue changes ------------------------------------ */
        useEffect(() => {
          if (!data) return; // nothing to paint yet
          const canvas = canvasRef.current;
          if (!canvas) return;
       
          const ctx = canvas.getContext("2d");
          const W = canvas.width;
          const H = canvas.height;
       
          /* ========= clear & background */
          ctx.clearRect(0, 0, W, H);
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, W, H);
       
          /* ========= random faint bezier curves (extra distortion) */
          for (let i = 0; i < 3; i++) {
            ctx.beginPath();
            ctx.moveTo(Math.random() * W, Math.random() * H);
            ctx.bezierCurveTo(
              Math.random() * W,
              Math.random() * H,
              Math.random() * W,
              Math.random() * H,
              Math.random() * W,
              Math.random() * H
            );
            ctx.lineWidth = 1 + Math.random(); // 1-2 px
            ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
            ctx.stroke();
          }
       
          /* ========= characters (uneven) */
          ctx.font = "bold 22px Arial";
          ctx.fillStyle = "#0A3A72";
          const chars = data.toString().split("");
       
          chars.forEach((ch, i) => {
            const angle = (Math.random() - 0.5) * 0.8; // ±23°
            const x = 8 + i * 14 + (Math.random() * 4 - 2);
            const y = 22 + (Math.random() * 6 - 3);
       
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(angle);
            ctx.fillText(ch, 0, 0);
            ctx.restore();
          });
       
          /* ========= dots */
          for (let i = 0; i < 45; i++) {
            ctx.beginPath();
            ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
            ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
            ctx.fill();
          }
        }, [data]);
       
        /* -- reload button click ------------------------------------------------------- */
        const handleReload = () => {
          fetch("https://api-uat.mawalog.com/admin/v2/api/website")
            .then((response) => response.json())
            .then((json) => {
              setData(json.data.captcha_code);
              setSessionid(json.data.session_id);
              setToken(json.data.token);
            })
            .catch((error) => console.error("Error fetching data:", error));
        };
          const handleSubscribe = async () => {
          try {
            const response = await fetch(
              "https://api-uat.mawalog.com/admin/v2/api/newsletter",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-CSRF-TOKEN": token,
                },
                body: JSON.stringify({
                  session_id: sessionid,
                  captcha: userCaptcha,
                  email: email,
                  type: "Mawalog",
                }),
              }
            );
       
            const result = await response.json();
            console.log("Response:", userCaptcha, " ", data);
            setEmail("");
           setUserCaptcha("");
            toast(result.message);
          } catch (error) {
            console.error("Error sending request:", error);
          }
        };
        const [openDropdown, setOpenDropdown] = useState(null);
        const navRef = useRef(null);
      
        // Close dropdown on outside click
        useEffect(() => {
          const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
              setOpenDropdown(null);
            }
          };
          document.addEventListener('mousedown', handleClickOutside);
          return () => document.removeEventListener('mousedown', handleClickOutside);
        }, []);
      
        const toggleDropdown = (dropdown) => {
          setOpenDropdown(openDropdown === dropdown ? null : dropdown);
        };
        
        const navigate = useNavigate();
       
        const handleClick = () => {
          navigate("/Contact#contact-section");
        };
          const [isOpen, setIsOpen] = useState(false);
                
                  // const toggleDropdown = () => {
                  //   setIsOpen((prev) => !prev);
                  // };
            
            
                  const [isServicesOpen, setIsServicesOpen] = useState(false);
              const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
              const [isCompanyOpen, setIsCompanyOpen] = useState(false);
            
              // Toggle functions for dropdowns
              const toggleServicesDropdown = () => {
                setIsServicesOpen(!isServicesOpen);
                setIsIndustriesOpen(false);
                setIsCompanyOpen(false); // Close other dropdowns
              };
            
              const toggleIndustriesDropdown = () => {
                setIsIndustriesOpen(!isIndustriesOpen);
                setIsServicesOpen(false);
                setIsCompanyOpen(false); // Close other dropdowns
              };
            
              const toggleCompanyDropdown = () => {
                setIsCompanyOpen(!isCompanyOpen);
                setIsServicesOpen(false);
                setIsIndustriesOpen(false); // Close other dropdowns
              };
                  const [word, setWord] = useState('Today');
            
              useEffect(() => {
                const interval = setInterval(() => {
                  setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
                }, 2000);
                return () => clearInterval(interval);
              }, []);
 

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    email: "",
    description: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handlleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    try {
      const response = await fetch("https://api-uat.mawalog.com/admin/v2/api/hire_us", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage("Your request was submitted successfully.");
        setFormData({
          name: "",
          mobile_number: "",
          email: "",
          description: "",
        });
      } else {
        setError("Submission failed. Please try again.");
      }
    } catch (err) {
      setError("Something went wrong. Please check your inputs.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    
 
    <div className="bg-white text-gray-800">
      {/* Header */}
     
  <div className="bg-[#F9FCD0] py-14 text-center px-4">
      {/* Job Title and Company Info */}
      <div className="text-gray-700 text-sm font-medium mb-3">
        Lentera Technologies <span className="mx-2">|</span> Full Time
      </div>
      <h1 className="text-3xl md:text-5xl font-semibold text-gray-900 mb-6">
        Sales and Marketing Associate
      </h1>

      {/* I'm Interested Button */}
      <button className="bg-[#F4B731] hover:bg-[#e5a925] text-black font-semibold px-6 py-3 rounded-md text-sm md:text-base transition-all duration-200">
        I’M INTERESTED <span className="ml-1">→</span>
      </button>

      {/* Divider Line */}
      <hr className="my-10 w-full max-w-xl mx-auto border-t border-gray-300" />

      {/* Share Icons */}
      
      <div className="flex justify-center items-center gap-2 mt-8">
  <span className="text-sm font-medium text-gray-700">SHARE IT TO</span>
  <span className="text-sm font-medium text-gray-700">:</span>
  <div className="flex gap-4">
    <img src={gmailIcon} alt="Gmail" className="w-10 h-10 bg-white rounded-xl p-2 shadow-sm" />
    <img src={xIcon} alt="X" className="w-10 h-10 bg-white rounded-xl p-2 shadow-sm" />
    <img src={facebookIcon} alt="Facebook" className="w-10 h-10 bg-white rounded-xl p-2 shadow-sm" />
    <img src={instagramIcon} alt="Instagram" className="w-10 h-10 bg-white rounded-xl p-2 shadow-sm" />
    <img src={linkedinIcon} alt="LinkedIn" className="w-10 h-10 bg-white rounded-xl p-2 shadow-sm" />
  </div>
</div>

    </div>
      {/* Content */}
     
    <div className="bg-white px-6 md:px-16 py-12">
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">

    {/* LEFT SIDE: JOB DESCRIPTION */}
    <div className="lg:col-span-2 space-y-12">
      {/* Section 1 */}
      <div>
        <h2 className="text-[32px] font-semibold text-[#212129] mb-6">Job description</h2>

        <h3 className="text-[20px] font-semibold text-green-600 mb-1">
          Sales and Marketing Fresher Qualifications
        </h3>
        <div className="w-[100px] h-[2px] bg-green-600 mb-6" />

        <ul className="space-y-6 text-[#212129] text-[18px] leading-8">
          {[
            "Design and develop high-volume, low-latency applications for mission-critical systems, ensuring top-tier availability and performance.",
            "Contribute to all phases of the product development lifecycle.",
            "Write well-designed, testable, and efficient code.",
            "Ensure designs comply with specifications.",
            "Prepare and produce releases of software components.",
            "Support continuous improvement by investigating alternate technologies and presenting these for architectural review.",
          ].map((text, i) => (
            <li key={i} className="flex gap-3">
              <span className="mt-2 w-2 h-2 bg-green-500 rounded-full shrink-0" />
              <span>{text}</span>
            </li>
          ))}
        </ul>

        <p className="mt-8 text-[18px] text-[#212129] leading-7">
          Please note that we have requirements for this role in Chennai, Salem, Coimbatore, Tirunelveli, and Madurai.
        </p>
      </div>

      {/* Section 2 */}
      <div>
        <h3 className="text-[20px] font-semibold text-green-600 mb-1">
          Education and Experience Requirements
        </h3>
        <div className="w-[100px] h-[2px] bg-green-600 mb-6" />

        <ul className="space-y-6 text-[#212129] text-[18px] leading-8">
          {[
            "Design and develop high-volume, low-latency applications for mission-critical systems.",
            "Contribute to all phases of the product development lifecycle.",
            "Write well-designed, testable, and efficient code.",
            "Ensure designs comply with specifications.",
            "Prepare and produce releases of software components.",
            "Support continuous improvement by researching new technologies.",
          ].map((text, i) => (
            <li key={i} className="flex gap-3">
              <span className="mt-2 w-2 h-2 bg-green-500 rounded-full shrink-0" />
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>

    {/* RIGHT SIDE: JOB INFORMATION */}
    <div className="w-full max-w-sm">
      <h2 className="text-[28px] font-semibold text-[#212129] mb-6">Job Information</h2>

      {[
        {
          icon: "locationIcon",
          label: "Location",
          value: "Chennai",
          iconSrc: locationIcon,
        },
        {
          icon: "fulltimeIcon",
          label: "Job type",
          value: "Full time",
          iconSrc: fulltimeIcon,
        },
        {
          icon: "experienceIcon",
          label: "Experience",
          value: "0–3 years",
          iconSrc: experienceIcon,
        },
      ].map((item, i) => (
        <div
          key={i}
          className="flex items-center bg-[#F9FAFB] rounded-2xl px-5 py-4 mb-4 shadow-sm"
        >
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mr-4">
            <img src={item.iconSrc} alt={item.label} className="w-5 h-5" />
          </div>
          <div>
            <p className="text-sm text-gray-400">{item.label}</p>
            <p className="text-sm font-medium text-[#212129]">{item.value}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>


      {/* Apply Form */}
      
    </div>
    <div className="min-h-screen bg-[#f6f9fe] flex justify-center items-start py-20 px-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-xl bg-[#f6f9fe] space-y-6"
      >
        <h1 className="text-4xl font-semibold text-[#212129] mb-2">Hire Us</h1>
        <p className="text-[#212129] text-[16px] leading-7">
          Please fill in the details below to initiate the hiring process for
          this role.
        </p>

        {/* Name */}
        <div>
          <label className="block text-[#212129] font-semibold mb-2">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full border border-green-600 rounded-md px-4 py-3 focus:border-green-600 focus:outline-none transition"
            placeholder="Enter your name"
          />
        </div>

        {/* Phone Number */}
        <div>
          <label className="block text-[#212129] font-semibold mb-2">Phone number</label>
          <input
            type="tel"
            name="mobile_number"
            value={formData.mobile_number}
            onChange={handleChange}
            required
            className="w-full border border-gray-200 rounded-md px-4 py-3 focus:border-green-600 focus:outline-none transition"
            placeholder="Enter your phone number"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-[#212129] font-semibold mb-2">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full border border-gray-200 rounded-md px-4 py-3 focus:border-green-600 focus:outline-none transition"
            placeholder="Enter your email"
          />
        </div>

        {/* Description */}
        <div>
          <label className="block text-[#212129] font-semibold mb-2">
            How can we help you?*
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows="3"
            required
            className="w-full border border-gray-200 rounded-md px-4 py-3 focus:border-green-600 focus:outline-none transition"
            placeholder="Type your message here..."
          ></textarea>
        </div>

        {/* Messages */}
        {error && <p className="text-red-600 font-medium">{error}</p>}
        {message && <p className="text-green-600 font-medium">{message}</p>}

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-green-700 hover:bg-green-800 text-white font-semibold py-3 rounded-md transition"
        >
          {loading ? "Submitting..." : "SUBMIT"}
        </button>
      </form>
    </div>
    <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
       {/* Top newsletter */}
       <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
         {/* Left Side */}
         <div className="flex items-start md:items-center gap-4 md:gap-6">
           <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
           <h2 className="text-xl md:text-[28px] font-bold leading-tight">
             Join our newsletter to <br className="hidden md:block" />
             keep up to date with us!
           </h2>
         </div>
 
   <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
  {/* Newsletter input */}
 <div
  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
  style={{ borderRadius: "6px" }}
>
  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
  <input
    type="email"
    value={email}
    onChange={handleChange}
    placeholder="Enter your email"
    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
  />
</div>
 
 
  {/* Captcha line (canvas + refresh + input + subscribe button) */}
{/* Outer wrapper to center the row */}
<div className="w-full flex justify-center">
  <div className="flex items-center gap-3">
    {/* Captcha canvas */}
    <div className="captcha-box">
      <canvas
        ref={canvasRef}
        id="captchaCanvas"
        width={60}
        height={40}
        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
      />
    </div>
 
    {/* Refresh button */}
    <button
      onClick={handleReload}
      style={{
        background: "#07862B ",
        color: "#fff",
        border: "none",
        padding: "6px",
        borderRadius: "6px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
      </svg>
    </button>
 
    {/* Captcha input */}
    <input
      type="text"
      placeholder="Enter captcha"
      value={userCaptcha}
      onChange={(e) => setUserCaptcha(e.target.value)}
      className="captcha-input"
    />
 
    {/* Subscribe button */}
    <button className="subscribe-button" onClick={handleSubscribe}>
      Subscribe
    </button>
  </div>
</div>
 
<style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>
 
</div>
       </div>
 
       {/* Divider */}
       <div className="border-t border-gray-700 w-full" />
 
       {/* Main Footer Content */}
       <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
         {/* Company Info */}
         <div className="w-full lg:w-[30%]">
           <a href="/" aria-label="Lentera Home">
  <img src={nlen} alt="Lentera logo" className="mb-6" />
</a>
           <p className="text-[#d4d4d4] leading-relaxed">
             We are highly experienced in offering software development, mobile
             application development, software consulting and project management
             delivery.
           </p>
           {/* Social Icons */}
           <div className="flex gap-4 mt-6 flex-wrap">
  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
    <img src={inst} alt="Instagram" className="w-8 h-8" />
  </a>
  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
    <img src={face} alt="Facebook" className="w-8 h-8" />
  </a>
  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={you} alt="YouTube" className="w-8 h-8" />
  </a>
  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
  </a>
  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
    <img src={twi} alt="X" className="w-8 h-8" />
  </a>
</div>

         </div>
 
         {/* Services */}
           <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
</ul>
         </div>
 
 
         {/* Insights */}
         <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
</ul>
         </div>
 
         {/* Contact */}
         <div className="w-full md:w-auto">
                    <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                        <div className="flex items-start gap-3 mb-3">
                    <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                    <div>
                      <p className="text-[#999] text-sm">Phone number</p>
                      <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                        +91-44-4856-3345
                      </a>
                    </div>
                  </div>
         
         <div className="flex items-start gap-3 mb-3">
           <img src={mail} alt="email" className="w-9 h-9 mt-1" />
           <div>
             <p className="text-[#999] text-sm">Email address</p>
             <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
               info@lenteratech.com
             </a>
           </div>
         </div>
         
                    <div className="flex items-start gap-3">
           <img src={loc} alt="location" className="w-9 h-9 mt-1" />
           <div>
             <p className="text-[#999] text-sm">Location</p>
             <a
               href="https://www.google.com/maps/place/G1,+Plot+No,+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
               target="_blank"
               rel="noopener noreferrer"
               className="text-white font-medium text-sm hover:underline block"
             >
               G1, Plot No, 824 and 826, 3rd<br />
               Main Rd, Ram Nagar South,<br />
               Madipakkam, Chennai,<br />
               Tamil Nadu 600091
             </a>
           </div>
         </div>
         
                  </div>
       </div>
     </div>
   </footer>
 
   {/* Bottom Section */}
  <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>
    </>
    
  );
};

export default HireUsForm;
